import {
  ACCEPT_SHIFT_REQUEST_FAIL,
  ACCEPT_SHIFT_REQUEST_SUCCESS,
  ADD_OPEN_SHIFT_FAIL,
  ADD_OPEN_SHIFT_SUCCESS,
  DELETE_OPEN_SHIFTS_FAIL,
  DELETE_OPEN_SHIFTS_SUCCESS,
  GET_OPEN_SHIFTS,
  GET_OPEN_SHIFTS_FAIL,
  GET_OPEN_SHIFTS_SUCCESS,
  OPEN_SHIFT_REQUEST_LIST_FAIL,
  OPEN_SHIFT_REQUEST_LIST_SUCCESS,
  UPDATE_OPEN_SHIFT_FAIL,
  UPDATE_OPEN_SHIFT_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  list: [],
  error: [],
  res: [],
  loading: false,
  requestList: [],
};

const OpenShifts = (state = INIT_STATE, action) => {
  switch (action.type) {
    case DELETE_OPEN_SHIFTS_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case DELETE_OPEN_SHIFTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case OPEN_SHIFT_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        requestList: action.payload,
      };
    case OPEN_SHIFT_REQUEST_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ACCEPT_SHIFT_REQUEST_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ACCEPT_SHIFT_REQUEST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_OPEN_SHIFTS:
      return {
        ...state,
        loading: true,
      };
    case GET_OPEN_SHIFTS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
      };
    case GET_OPEN_SHIFTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ADD_OPEN_SHIFT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ADD_OPEN_SHIFT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_OPEN_SHIFT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_OPEN_SHIFT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default OpenShifts;
